'use strict';

const debounce = require('lodash/debounce');

const isElementInViewport = function (el) {
    var $header = $('.experience-header');
    if (!el || el.length === 0) return false;
    const rect = el.getBoundingClientRect();
    var isElementInViewportBoolean;
    if ($('body').hasClass('scroll-up') && $header.hasClass('hide-header')) {
        isElementInViewportBoolean = rect.top >= $header.outerHeight() && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    } else {
        isElementInViewportBoolean = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }
    return isElementInViewportBoolean;
};

const toggleStickyATBOnScroll = function () {
    const originalButton = $('.pdp-right-wrapper .prices-add-to-cart-actions')[0];

    const $stickyBar = $('.sticky-atb-bar');

    if ($stickyBar.length > 0) {
        if (!isElementInViewport(originalButton)) {
            $stickyBar.css('display', 'flex').fadeIn();
            $stickyBar.removeClass('d-none');
        } else {
            $stickyBar.fadeOut();
            $stickyBar.addClass('d-none');
        }
    }
};

const stickyHandler = function () {
    // Init call on page load
    toggleStickyATBOnScroll();
    // Adapt on scroll / resize
    $(window).on('orientationchange resize scroll', debounce(toggleStickyATBOnScroll, 25));
};

$('body').on('click', '.floating-add-to-cart-btn', function () {
    var $addToCartSlider = $('.add-to-cart-slider');
    if ($addToCartSlider.length && $addToCartSlider.is(':visible')) {
        $addToCartSlider.trigger('click');
    } else {
        $('.add-to-cart').first().trigger('click');
    }
});

$('body').on('click', '.floating-select-size-btn, .btn.selected-size', function () {
    $('.pdp-right-wrapper [data-attr=size] .attribute-btn').click();
});

module.exports = {
    toggleStickyATBOnScroll: toggleStickyATBOnScroll,
    isElementInViewport: isElementInViewport,
    stickyHandler: stickyHandler,
};
